var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedsmileimg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12437_6777)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 12C0 5.38317 5.38317 0 12 0C18.6168 0 24 5.38317 24 12C24 18.6168 18.6168 24 12 24C5.38317 24 0 18.6168 0 12ZM1.5 12C1.5 17.7897 6.21028 22.5 12 22.5C17.7897 22.5 22.5 17.7897 22.5 12C22.5 6.21028 17.7897 1.5 12 1.5C6.21028 1.5 1.5 6.21028 1.5 12ZM7.06369 7.54355C6.2362 7.54355 5.56303 8.21677 5.56303 9.0442C5.56303 9.87169 6.2362 10.5449 7.06369 10.5449C7.89117 10.5449 8.56434 9.87169 8.56434 9.0442C8.56434 8.21672 7.89117 7.54355 7.06369 7.54355ZM16.9364 10.5449C17.7638 10.5449 18.437 9.87164 18.437 9.0442C18.437 8.21677 17.7638 7.54359 16.9364 7.54355C16.1089 7.54355 15.4357 8.21672 15.4357 9.0442C15.4357 9.87169 16.1089 10.5449 16.9364 10.5449ZM11.9998 14.5311C9.35295 14.5311 6.98989 15.8869 5.67865 18.1578C5.47156 18.5165 5.59442 18.9752 5.95315 19.1823C6.31184 19.3895 6.77056 19.2666 6.97765 18.9079C8.01776 17.1066 9.89525 16.0311 11.9999 16.0311C14.1046 16.0311 15.9822 17.1065 17.0224 18.9079C17.2295 19.2665 17.6882 19.3894 18.0469 19.1823C18.4056 18.9752 18.5285 18.5165 18.3214 18.1578C17.01 15.8868 14.6468 14.5311 11.9998 14.5311Z",
    fill: "#DC3545"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12437_6777"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedsmileimg);
export default __webpack_public_path__ + "static/media/redsmileimg.af891ea724b64d9d6cce6d722483acf7.svg";
export { ForwardRef as ReactComponent };